<template>
<div>
	<v-card flat max-width="950px" class="mx-auto transparent mb-12 pb-12">

        <div class="headline font-weight-bold primary--text ml-6 mt-6">TO DO</div>

        <v-row class="mt-6 mt-sm-12">
            <v-col cols="12" sm="6">
                <div class="d-flex justify-center justify-sm-end mr-sm-6">
                    <v-card flat width="300px" hover color="#CEFF80" @click="$router.push('/molecule')">
                        <v-btn fab text absolute x-small class="mt-6 mr-n2" top right @click.stop="show('molecule')">
                            <v-icon size="20" color="primary" style="opacity:.3">fa-info-circle</v-icon>
                        </v-btn>
                        <div class="d-flex align-center">
                            <div class="mx-6">
                                <v-img :src="require('@/assets/homesIcons/molecule.png')" width="40"></v-img>
                            </div>
                            <div class="title font-weight-bold primary--text py-6">
                                MOLECULE
                            </div>
                        </div>
                    </v-card>
                </div>
            </v-col>

            <v-col cols="12" sm="6">
                 <div class="d-flex justify-center justify-sm-start ml-sm-6">
                    <v-card flat width="300px" hover color="#FF6813" @click="$router.push('/map-of-careers')">
                        <v-btn fab text absolute x-small class="mt-6 mr-n2" top right @click.stop="show('career-map')">
                            <v-icon size="20" color="primary" style="opacity:.3">fa-info-circle</v-icon>
                        </v-btn>
                        <div class="d-flex align-center">
                            <div class="mx-6">
                                <v-img :src="require('@/assets/homesIcons/career-map.png')" width="40"></v-img>
                            </div>
                            <div class="title font-weight-bold primary--text py-6">
                                CAREER MAP
                            </div>
                        </div>
                    </v-card>
                 </div>
            </v-col>
        </v-row>

        <v-row class="mt-sm-4">
            <v-col cols="12" sm="6">
                <div class="d-flex justify-center justify-sm-end mr-sm-6">
                    <v-card flat width="300px" hover color="#6E91E6" @click="$router.push('/map-of-life')">
                        <v-btn fab text absolute x-small class="mt-6 mr-n2" top right @click.stop="show('life-map')">
                            <v-icon size="20" color="primary" style="opacity:.3">fa-info-circle</v-icon>
                        </v-btn>
                         <div class="d-flex align-center">
                            <div class="mx-6">
                                <v-img :src="require('@/assets/homesIcons/life-path.png')" width="40"></v-img>
                            </div>
                            <div class="title font-weight-bold primary--text py-6">
                                LIFE MAP
                            </div>
                        </div>
                    </v-card>
                </div>
            </v-col>

            <v-col cols="12" sm="6">
                 <div class="d-flex justify-center justify-sm-start ml-sm-6">
                    <v-card flat width="300px" hover color="#FF5B71" @click="$router.push('/my-top3')">
                        <v-btn fab text absolute x-small class="mt-6 mr-n2" top right @click.stop="show('top-3')">
                            <v-icon size="20" color="primary" style="opacity:.3">fa-info-circle</v-icon>
                        </v-btn>
                        <div class="d-flex align-center">
                            <div class="mx-6">
                                <v-img :src="require('@/assets/homesIcons/top-3.png')" width="40"></v-img>
                            </div>
                            <div class="title font-weight-bold primary--text py-6">
                                TOP 3
                            </div>
                        </div>
                    </v-card>
                 </div>
            </v-col>
        </v-row>

        <v-row class="mt-sm-4">
            <v-col cols="12">
                <div class="d-flex justify-center">
                    <v-card flat width="300px" hover color="#AAD3FF" @click="$router.push('/planner/p/own')">
                        <v-btn fab text absolute x-small class="mt-6 mr-n2" top right @click.stop="show('reputation-planner')">
                            <v-icon size="20" color="primary" style="opacity:.3">fa-info-circle</v-icon>
                        </v-btn>
                        <div class="d-flex align-center">
                            <div class="mx-6">
                                <v-img :src="require('@/assets/homesIcons/top-3.png')" width="40"></v-img>
                            </div>
                            <div class="subtitle-1 font-weight-bold primary--text py-6">
                                REPUTATION PLANNER
                            </div>
                        </div>
                    </v-card>
                </div>
            </v-col>
        </v-row>

	</v-card>

    <DiagInfo
        :model="showDiag" 
        @accept="showDiag=false"
        :text="textDiag"/>
</div>
</template>

<script>
export default {
    data: () => ({
        showDiag: false,
        textDiag: ''
    }),
    methods: {
        show(str) {
            if (str == 'molecule') {
                this.textDiag = "<div class='headline font-weight-medium primary--text'>Molecule</div> <div class='mt-2'>This is your personal brand. What five words do you want to pop up in people's minds when they think of you? How do you want to feel when you're at your job? What are your strengths? Interests? These are all questions that will help you discover more about yourself so you can start planning your future.</div>"
            }

            if (str == 'career-map') {
                this.textDiag = "<div class='headline font-weight-medium primary--text'>Career Map</div> <div class='mt-2'>All the facts you need to know about a job or college are usually spread out all over google and takes forever find. This is where the career map comes in. It has all the information you need and a little more to help you plan out your life in just a couple clicks.</div>"
            }

            if (str == 'life-map') {
                this.textDiag = "<div class='headline font-weight-medium primary--text'>Life Map</div> <div class='mt-2'>To live your dream life, you need to have a plan to set goals and achieve that vision. The more details, the better. Inside each goal, you have to think of what actions you will need to take to obtain the resources you need, and what resources you already have (ex. Goal: Adopt a dog, Have: A house with a backyard, Need: $2000, Action: Get a job and start saving money). Just follow the steps, and you'll have a GPS for life.</div>"
            }

            if (str == 'top-3') {
                this.textDiag = "<div class='headline font-weight-medium primary--text'>Top 3</div> <div class='mt-2'>Your top 3 will reflect the goals and visions of your life map and career map. Once you decide on your dream job (and backups), you can start looking into the best majors and what universities offer them. In the end, you will not only have three of everything, but through researching, you will have learned more about the job, what qualifications are needed, the best companies to work for, and your best-fit university.</div>"
            }

            if (str == 'reputation-planner') {
                this.textDiag = "<div class='headline font-weight-medium primary--text'>Reputation Planner</div> <div class='mt-2'>LinkedIn is where every company and person holds its reputation. It's vital for you for colleges and companies to see you in the right light. The reputation planner is here to test out ideas so that when you start on your real LinkedIn profile, it will be professional and make you stand out from any other candidates.</div>"
            }

            this.showDiag = true;
        }
    }
}
</script>
